import { Autocomplete, Box, Checkbox, Chip, Paper, TextField } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { TRIP_DIRECTION, TRIP_DIRECTION_NAMES } from '../constants';
import {
  calendarFilterCheckboxSx,
  calendarFilterCountChipSx,
  calendarFilterAutocompleteSx,
  calendarFilterTextFieldSx,
} from './filterStyles';

const FixedWidthPaper = styled(Paper)(() => ({
  width: 220,
}));

const directionOptions = Object.values(TRIP_DIRECTION).map((direction) => ({
  value: direction,
  label: TRIP_DIRECTION_NAMES[direction],
}));

DirectionFilter.propTypes = {
  directionFilter: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  handleDirectionFilterChange: PropTypes.func.isRequired,
};

export function DirectionFilter({ directionFilter, handleDirectionFilterChange }) {
  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      openOnFocus
      options={directionOptions}
      value={directionFilter}
      onChange={handleDirectionFilterChange}
      popupIcon={<KeyboardArrowDownIcon sx={{ color: '#707070', fontSize: 16 }} />}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          size="small"
          autoComplete="off"
          sx={calendarFilterTextFieldSx}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <Box
                sx={{ display: 'flex', alignItems: 'center', pointerEvents: 'none' }}
                className="filter-autocomplete-adornment"
              >
                <Box component="span" sx={{ fontSize: '14px', color: '#707070' }}>
                  Direction
                </Box>
                {directionFilter.length > 0 ? (
                  <Chip label={directionFilter.length} size="small" sx={{ ...calendarFilterCountChipSx, ml: '8px' }} />
                ) : null}
              </Box>
            ),
          }}
        />
      )}
      renderOption={(props, option, { selected }) => (
        <li {...props} key={option.value}>
          <Checkbox sx={calendarFilterCheckboxSx} checked={selected} />
          {option.label}
        </li>
      )}
      ListboxProps={{ sx: calendarFilterAutocompleteSx }}
      PaperComponent={FixedWidthPaper}
      sx={{ ...calendarFilterAutocompleteSx, ml: 2, minWidth: 136, maxWidth: 136 }}
    />
  );
}
